import { SVGProps } from 'react'

const BoxIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M5.33359 13.9995C5.09978 13.9993 4.87013 13.9376 4.6677 13.8205C4.46527 13.7035 4.29717 13.5353 4.18026 13.3328L1.51359 8.66618C1.39657 8.46349 1.33496 8.23356 1.33496 7.99951C1.33496 7.76546 1.39657 7.53554 1.51359 7.33285L4.18026 2.66618C4.29717 2.46369 4.46527 2.2955 4.6677 2.17849C4.87013 2.06147 5.09978 1.99975 5.33359 1.99951L10.6669 1.99951C10.9007 1.99975 11.1304 2.06147 11.3328 2.17849C11.5353 2.2955 11.7034 2.46369 11.8203 2.66618L14.4869 7.33285C14.604 7.53554 14.6656 7.76546 14.6656 7.99951C14.6656 8.23356 14.604 8.46349 14.4869 8.66618L11.8203 13.3328C11.7034 13.5353 11.5353 13.7035 11.3328 13.8205C11.1304 13.9376 10.9007 13.9993 10.6669 13.9995H5.33359Z'
                stroke='#959699'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.66699 2.19922L8.00033 7.99922L4.66699 13.7992'
                stroke='#959699'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M14.6667 7.99951H8'
                stroke='#959699'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default BoxIcon
